export default "__VITE_ASSET__HihRHgLN__"